import React from "react";
import Accordion from 'react-bootstrap/Accordion';
import ListGroup from 'react-bootstrap/ListGroup';
import { useNavigate } from "react-router-dom";

type Props = {
    children?: React.ReactNode,
}

const Leftnav = ({
    children,
}: Props) => {

    const navigate = useNavigate();

    const handleItemClick = ({ targetUrl }) => {
        navigate(targetUrl);
    }

    return (
        <>
            <div className="Left-nav bg-light border-end">
                <div className="px-3 py-2 border-bottom">
                    <span>Dashboard</span>
                </div>
                <Accordion defaultActiveKey="0" flush>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Orders</Accordion.Header>
                        <Accordion.Body className="p-0">
                            <ListGroup as="ul">
                                <ListGroup.Item as="li" active action onClick={() => handleItemClick({ targetUrl: "/services" })} className="stretched-link">
                                    Service
                                </ListGroup.Item>
                                <ListGroup.Item as="li" action onClick={() => handleItemClick({ targetUrl: "/services/services-2" })} className="stretched-link">Services 2</ListGroup.Item>
                                <ListGroup.Item as="li" disabled>
                                    Morbi leo risus
                                </ListGroup.Item>
                                <ListGroup.Item as="li">Porta ac consectetur ac</ListGroup.Item>
                            </ListGroup>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Customers</Accordion.Header>
                        <Accordion.Body className="p-0">
                            <ListGroup as="ul">
                                <ListGroup.Item as="li" active>
                                    Cras justo odio
                                </ListGroup.Item>
                                <ListGroup.Item as="li">Dapibus ac facilisis in</ListGroup.Item>
                                <ListGroup.Item as="li" disabled>
                                    Morbi leo risus
                                </ListGroup.Item>
                                <ListGroup.Item as="li">Porta ac consectetur ac</ListGroup.Item>
                            </ListGroup>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Accordion Item #3</Accordion.Header>
                        <Accordion.Body className="p-0">
                            <ListGroup as="ul">
                                <ListGroup.Item as="li" active>
                                    Cras justo odio
                                </ListGroup.Item>
                                <ListGroup.Item as="li">Dapibus ac facilisis in</ListGroup.Item>
                                <ListGroup.Item as="li" disabled>
                                    Morbi leo risus
                                </ListGroup.Item>
                                <ListGroup.Item as="li">Porta ac consectetur ac</ListGroup.Item>
                            </ListGroup>
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Settings</Accordion.Header>
                    </Accordion.Item>
                </Accordion>
                {children}
            </div>
        </>
    )
}

export default Leftnav;
